import * as React from 'react';

import Alert, { AlertProps } from './components/alert/Alert';
import Button, { ButtonProps } from './components/button/Button';
import Hr, { HrProps } from './components/hr/Hr';

export { Button, ButtonProps, Alert, AlertProps, Hr, HrProps };
export default {
  React,
  Button,
  Alert,
  Hr,
};
